import { AxiosResponse } from 'axios';
import http from 'app/http';

const CONTENT_DELIVERY_API = '/api/episerver/v2.0/content/';

export function getContentByReference(
  reference?: string | number,
  expand?: boolean,
): Promise<AxiosResponse> {
  return http.get(`${CONTENT_DELIVERY_API}${reference}`);
}

export const getContentByUrl = (url: string, isPostRequest?: boolean, body?: any, config?: any): Promise<AxiosResponse> => {
  if (isPostRequest) {
    return http.post(url, body, config);
  }
  return http.get(`${url}`);
};

export const getContentChildren = (url?: string): Promise<AxiosResponse> => {
  return http.get(`${url}/children`);
};

export const getTransactionHistory = (
  url: string,
  body: FormData,
): Promise<AxiosResponse> => {
  return http.post(url, body);
};

export const postMakePayment = (path: string, body: any): Promise<AxiosResponse> => {
  return http.post(path, body);
}